document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.style.setProperty(
    '--header-height',
    `${parseInt(document.querySelector('header').offsetHeight)}px`
  );
  var content = document.querySelector('.metafield-rich_text_field');
  var maxHeight = 100;
  if (content && content.clientHeight > maxHeight) {
    content.style.overflow = 'hidden';
    content.style.maxHeight = maxHeight + 'px';
    content.insertAdjacentHTML(
      'afterend',
      '<a style="font-weight:bold;" href="#" id="readMoreLink" onclick="toggleContent(event)">קרא עוד...</a>'
    );
  }
});

function toggleContent(event) {
  event.preventDefault();
  var content = document.querySelector('.metafield-rich_text_field');
  var readMoreLink = document.getElementById('readMoreLink');

  if (content?.style?.maxHeight) {
    content.style.maxHeight = null;
    readMoreLink.textContent = 'קרא פחות';
  } else {
    var maxHeight = 100;
    content.style.maxHeight = maxHeight + 'px';
    readMoreLink.textContent = 'קרא עוד...';
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  // Cache focusable elements to avoid repeated DOM queries
  if (!container._focusableElements) {
    container._focusableElements = getFocusableElements(container);
  }
  var elements = container._focusableElements;
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class LinkArea extends HTMLElement {
  constructor() {
    super();

    let down,
      up,
      link = this.querySelector('a');

    this.down = down;
    this.up = up;
    this.link = link;
    this.url = this.link.getAttribute('href');
    this.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseDown(event) {
    this.down = +new Date();
  }

  onMouseUp(event) {
    this.up = +new Date();
    if (this.up - this.down < 700) {
      const openInNewTab = (event.button === 0 && (event.ctrlKey || event.metaKey)) || event.button === 1;
      // const openInNewWindow (event.button === 0 && event.shiftKey)

      let target = event.target;
      let quickbuy = target.closest('.qb');
      if (quickbuy) {
        let sizeItem = target.closest('.qb-size-item');
        if (!(sizeItem && quickbuy.classList.contains('qb-passthrough'))) {
          return false;
        }
      }

      if (openInNewTab) {
        this.openInNewTab(this.link);
      } else if (event.button === 0) {
        this.open(this.link.href);
      }
    }
  }

  open(href) {
    this.classList.add('outline-auto');
    this.link.click();
    window.location.href = href;
  }

  openInNewTab(href) {
    window.open(href, '_blank').focus();
  }
}

customElements.define('link-area', LinkArea);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    document.documentElement.style.setProperty(
      '--header-height',
      `${parseInt(document.querySelector('header').innerHeight)}px`
    );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      // Use requestAnimationFrame instead of setTimeout for better performance
      requestAnimationFrame(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');

        // Defer trapFocus to avoid blocking
        if (!reducedMotion || reducedMotion.matches) {
          requestAnimationFrame(addTrapFocus);
        } else {
          summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }
      });
    }
  }

  openMenuDrawer(summaryElement) {
    // Use requestAnimationFrame for immediate visual feedback
    requestAnimationFrame(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', true);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

      // Defer trapFocus to next frame to avoid blocking
      requestAnimationFrame(() => {
        trapFocus(this.mainDetailsToggle, summaryElement);
      });
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    // Batch all layout reads together to prevent thrashing
    const headerBottom = this.header.getBoundingClientRect().bottom;
    const headerHeight = document.querySelector('header').offsetHeight;
    const viewportHeight = window.innerHeight;

    // Then batch all DOM writes together in a single animation frame
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(headerBottom - this.borderOffset)}px`
      );
      document.documentElement.style.setProperty(
        '--header-height',
        `${parseInt(headerHeight)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);

      this.header.classList.add('menu-open');
      this.mainDetailsToggle.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', true);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

      // Defer trapFocus to next frame to avoid blocking
      requestAnimationFrame(() => {
        trapFocus(this.mainDetailsToggle, summaryElement);
      });
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.dataset.autoplay) {
      this.loadContent(false, true);
    }
  }

  loadContent(focus = true, autoplay = false) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      if (focus) deferredElement.focus();
      if ((deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) || autoplay) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VideoSimple extends HTMLElement {
  constructor() {
    super();

    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.video = null;
    this.restoreState = null;
    this.videoObserver = null;
    this.autoplay = this.hasAttribute('autoplay');

    const mediaQuery = this.getAttribute('load-when-match-media');
    if (mediaQuery) {
      let mediaQueryList = window.matchMedia(mediaQuery);
      mediaQueryList.addEventListener('change', this.handleMediaMatch.bind(this));

      if (!mediaQueryList.matches) return;
    }

    if (!this.autoplay) {
      this.poster.addEventListener('click', this.handleClickPlay.bind(this));
    } else {
      this.loadContent();
    }
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.video = this.appendChild(content.querySelector('video'));

      if (focus) this.video.focus();

      if (this.video.hasAttribute('autoplay')) {
        // force autoplay for safari
        this.video.play();
      }

      const options = {
        threshold: 0.5,
      };

      const callback = (entries) => {
        if (entries[0].target !== this.video) return;
        if (!entries[0].isIntersecting) {
          this.shouldResumePlay = !this.video.paused;
          this.video.pause();
        } else if (this.shouldResumePlay) {
          this.video.play();
        }
      };

      let observer = new IntersectionObserver(callback, options);
      observer.observe(this.video);

      this.videoObserver = observer;

      this.setAttribute('loaded', true);
    }
  }

  handleClickPlay() {
    this.loadContent();
    this.video.play();
  }

  handleMediaMatch(mql) {
    if (mql.matches) {
      if (!this.autoplay) {
        this.poster.addEventListener('click', this.handleClickPlay.bind(this));
      } else {
        this.loadContent();
      }
    } else {
      this.videoObserver?.disconnect();
      this.video?.remove();
      this.removeAttribute('loaded');
    }
  }
}

customElements.define('video-simple', VideoSimple);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: currentElement,
            },
          })
        );
      }
    }

    if (this.enableSliderLooping) return;

    if (this.sliderItemsToShow[0] && this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    const lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (lastSlide && this.isSlideVisible(lastSlide)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    // Fix for iOS RTL scroll position on mobile
    if (window.innerWidth < 750) {
      setTimeout(() => {
        const computedStyle = window.getComputedStyle(this);
        if (computedStyle.direction === 'rtl') {
          // Reset to first slide for RTL mobile
          this.slider.scrollTo({
            left: 0,
            behavior: 'instant'
          });
          this.currentPage = 1;
          this.update();
        }
      }, 0);
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    const currentButton = this.sliderControlButtons[this.currentPage - 1];
    if (currentButton) {
      currentButton.classList.add('slider-counter__link--active');
      currentButton.setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft - this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    //const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    let target = event.target;
    let link;

    link = target.getAttribute('data-target');
    if (target.getAttribute('class') == 'dot') {
      link = target.parentNode.getAttribute('data-target');
    }
    let dest = document.querySelector('.thumbnail-slider [data-target="' + link + '"] button');

    dest.click();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

var isAvailable = true;
var testu;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.renderProductInfo();
    this.updateMedia();
    this.updateSku();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.updateURL();
      this.updateShareUrl();
    }
  }

  updateSku() {
    if (!this.currentVariant) return;
    let elem = document.querySelector('.psku');
    elem.innerHTML = this.currentVariant.sku;
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const activeElementId = document.activeElement.id;
    if (!this.currentVariant) {
      isAvailable = false;
      this.variantData.forEach((variant) => {
        if (variant.option1 == this.options[0]) {
          this.currentVariant = {
            id: variant.id,
            featured_media: variant.featured_media,
            available: false,
          };

          //{% comment %} *** Start of VertoSpin Code *** {% endcomment %}
          this.currentVariant.sku = variant.sku;
          //{% comment %} *** End of VertoSpin Code *** {% endcomment %}
        }
      });
    }

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        testu = html;
        if (!isAvailable) {
          html.querySelector(".select__select[name='options[size]']").forEach((elem) => {
            if (elem.value == this.options[1]) {
              elem.setAttribute('selected', 'selected');
            } else {
              elem.removeAttribute('selected');
            }
          });
        }
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const variantPickerDestination =
          document.getElementById(`variant-radios-${this.dataset.section}`) ||
          document.getElementById(`variant-selects-${this.dataset.section}`);
        const variantPickerSource =
          html.getElementById(
            `variant-radios-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          ) ||
          html.getElementById(
            `variant-selects-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

        const colorSwatchDestination = document.getElementById(`color-swatch`);
        const colorSwatchSource = html.getElementById(`color-swatch`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (variantPickerSource && variantPickerDestination)
          variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
        if (colorSwatchSource && colorSwatchDestination) colorSwatchDestination.innerHTML = colorSwatchSource.innerHTML;

        if (this.is_dynamic_images) {
          const mediaGalleryDestination = document.getElementById(`MediaGallery-${this.dataset.section}`);
          const mediaGallerySource = html.getElementById(
            `MediaGallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

          if (mediaGallerySource && mediaGalleryDestination) {
            mediaGalleryDestination.remove();
            document.querySelector('.grid__item.product__media-wrapper').append(mediaGallerySource);
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.currentVariant.isRealVariant = this.currentVariant.name ? true : false;
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
          true,
          this.currentVariant.isRealVariant
        );
        document.querySelector('variant-radios')
          ? this.querySelector(`[for="${activeElementId}"]`).focus()
          : document.querySelector(`#${activeElementId}`).focus();

        //{% comment %} *** Start of VertoSpin Code *** {% endcomment %}
        runVertoSpin(
          this.currentVariant ? this.currentVariant.sku.substr(0, this.currentVariant.sku.lastIndexOf('-')) : ''
        );
        //{% comment %} *** End of VertoSpin Code *** {% endcomment %}

        if (!isAvailable) {
          this.currentVariant = undefined;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, elVariantos) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const notifyButton = document.querySelector('.restock-rocket-button');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (elVariantos !== undefined) {
        addButton.style.display = 'none';
        if (notifyButton) notifyButton.style.display = 'block';
      } else {
        addButton.style.display = 'flex';
        if (notifyButton) notifyButton.style.display = 'none';
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.is_dynamic_images =
      this.is_dynamic_images || JSON.parse(this.querySelector('#dynamic-gallery-meta').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    const target = document.getElementById(e.target.dataset.targetId);
    target.value = e.target.value;

    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: false,
    });
    target.dispatchEvent(changeEvent);
  }
}

customElements.define('color-swatches', ColorSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
class ProductCard extends LinkArea {
  constructor() {
    super();
    this.linkToItem = this.linkToItem.bind(this);
    this.url = this.querySelector('.card__main-link').getAttribute('href');
    this.productMedia = this.querySelector('.card__media img:first-of-type');
    this.price = this.querySelector('.price');
    this.discount = this.querySelector('.hc-sale-tag');
    this.originalPrice = this.price.innerHTML;
    this.siblingList = this.querySelector('.card__sibling-list');
    this.siblingCount = Number(this.siblingList.dataset.siblingCount);
    this.lazySiblingListTemplate = this.querySelector('template');
    this.siblingList.addEventListener('click', (e) => {
      let target = e.target.closest('.card__sibling-list-item');
      if (target) {
        e.preventDefault();
        this.linkToItem(target);
      }
    });
    this.siblingListState = 'closed';

    if (this.siblingList && this.siblingCount > 2) {
      const observer = new ResizeObserver(this.onElemResize.bind(this));
      observer.observe(this.siblingList);
    }
  }

  onElemResize(entries) {
    if (this.siblingListState === 'open') return;

    const { gridTemplateColumns } = getComputedStyle(this.siblingList);
    const columns = gridTemplateColumns.split(' ').length;
    const rows = Math.ceil(this.siblingCount / columns);
    const entry = entries[0];
    const gridGap = 8;
    const height = entry.contentRect.height;

    const showMoreEl = this.querySelector('.card__sibling-list-show-more-toggle');

    if (rows > 1) {
      const itemCount = this.siblingCount;
      const hiddenItemCount = itemCount - columns + 1;

      showMoreEl.querySelector('span').textContent = '+' + hiddenItemCount;
      showMoreEl.classList.remove('hidden');

      showMoreEl.addEventListener('click', (event) => {
        this.siblingListState = 'open';
        this.siblingList.style.maxHeight = height + 'px';

        if (this.lazySiblingListTemplate?.content) {
          const clone = this.lazySiblingListTemplate.content.cloneNode(true);
          this.siblingList.appendChild(clone);
          this.lazySiblingListTemplate.remove();
        }

        window.requestAnimationFrame(() => {
          this.siblingList.style.maxHeight = `${height * rows + gridGap * (rows - 1)}px`;
          this.siblingList.classList.remove('card__sibling-list--show-more');
          this.siblingList.classList.add('card__sibling-list--show-all');
          showMoreEl.remove();

          window.requestAnimationFrame(() => {
            this.siblingList.style.maxHeight = 'auto';
          });
        });
      });
    } else {
      showMoreEl.classList.add('hidden');
    }
  }

  onMouseUp(event) {
    if (event.target.closest('.card__sibling-list')) return;
    super.onMouseUp(event);
  }

  linkToItem(item) {
    this.siblingList.querySelectorAll('.card__sibling-list-item').forEach((item) => {
      item.classList.remove('card__sibling-list-item--selected');
    });
    item.classList.add('card__sibling-list-item--selected');

    const variantSrc = this.cleanImageSrc(item.dataset.src);
    const mainSrc = this.cleanImageSrc(this.productMedia.src);

    const updateMediaAttribute = (att) => {
      this.productMedia.setAttribute(att, this.productMedia[att].replaceAll(mainSrc, variantSrc));
    };

    ['currentSrc', 'src', 'srcset'].forEach(updateMediaAttribute);

    this.productMedia?.nextElementSibling?.remove();

    this.updateItemPrice(item);
    this.updateItemSaleLabel(item);

    const itemUrl = item.querySelector('a').getAttribute('href');
    const itemTitle = item.dataset.title;
    this.querySelectorAll('.card__main-link').forEach((link) => {
      link.setAttribute('href', itemUrl);
      link.setAttribute('title', itemTitle);
      link.textContent = itemTitle;
    });
    this.url = itemUrl;
    let variantId = item.getAttribute('data-sibling-id');
    if (variantId) {
      const activeItem = new CustomEvent('activeSibling', {
        bubbles: true,
        detail: {
          id: variantId,
        },
      });
      item.dispatchEvent(activeItem);
    }
  }

  updateItemSaleLabel(item) {
    const discountAmount = item.dataset.discountAmount;

    if (this.discount) {
      this.discount.classList.add('hidden');
    }

    if (!discountAmount) {
      return;
    }

    if (!this.discount) {
      this.discount = document.createElement('div');
      let span = document.createElement('span');
      span.textContent = discountAmount;
      this.discount.classList = 'hc-sale-tag';
      this.discount.appendChild(span);
      this.querySelector('.card__media').prepend(this.discount);
      return;
    }
    this.discount.querySelector('span').innerHTML = discountAmount;
    this.discount.classList.remove('hidden');
  }

  updateItemPrice(item) {
    const rawPriceData = item.dataset.price;

    if (!rawPriceData.trim()) {
      this.price.innerHTML = this.originalPrice;
      this.price.classList.remove('price--on-sale');
      return;
    }

    let priceData = null;

    try {
      priceData = JSON.parse(item.dataset.price);
    } catch (e) {
      console.error(e);
    } finally {
      if (!priceData) return;
    }

    this.price.removeAttribute('class');
    this.price.classList.add(...priceData.classes);

    const salePriceContainer = this.price.querySelector('.price__sale');
    const regularPriceContainer = this.price.querySelector('.price__regular');

    regularPriceContainer.textContent = priceData.regular;
    salePriceContainer.querySelector('.price-item--sale').textContent = priceData.regular;

    const saleRegularPrice = salePriceContainer.querySelector('.price-item--regular');

    if (saleRegularPrice) {
      const span = saleRegularPrice.closest('span');
      span.previousElementSibling.remove();
      span.remove();
    }

    if (priceData.sale_html) {
      const newSaleHtml = document.createElement('div');
      newSaleHtml.insertAdjacentHTML('beforeend', priceData.sale_html.trim());
      salePriceContainer.prepend(...newSaleHtml.childNodes);
    }
  }

  cleanImageSrc(src) {
    const { host, pathname } = new URL(src.startsWith('http') ? src : `${location.protocol}//${src}`);
    return `//${host}${pathname}`;
  }
}

customElements.define('product-card', ProductCard);

// setTimeout(()=>{
//   document.querySelector('.bss_pl_img').setAttribute("readonly", "true")
//      document.getElementById('cbar_mq_css').remove();
// }, 9000)

/**
 * The activeSibling handler, registered ONCE for the whole document.
 *
 * It used to be registered from inside every <quick-buy> constructor, so a page with N
 * product cards ended up with N document-level listeners. Because the event bubbles up from
 * the clicked colour swatch, ONE click then ran the handler N times, and every one of those
 * runs did identical work on the same card. With a single page of 36 products that is
 * invisible. Once load-more stacks several pages onto one screen it is not: choosing a
 * colour, which is the most common action in a shoe shop, got slower the further the shopper
 * had scrolled.
 *
 * A single listener is functionally identical, because the handler already derives the card
 * from the event target rather than from the instance that registered it.
 */
let activeSiblingListenerBound = false;

function bindActiveSiblingListener() {
  if (activeSiblingListenerBound) return;
  activeSiblingListenerBound = true;

  document.addEventListener('activeSibling', (e) => {
    // Both lookups are null-guarded: this listener sees every activeSibling event on the
    // page, including ones from cards outside a .grid__item and ones whose matching size
    // list does not exist. Either one throwing used to abort the handler.
    const card = e.target.closest('.grid__item');
    if (!card) return;

    card.querySelectorAll('.items-list').forEach((list) => {
      list.classList.remove('active');
    });

    const target = card.querySelector('#Item_' + e.detail.id);
    if (target) target.classList.add('active');
  });
}

class QuickBuy extends HTMLElement {
  constructor() {
    super();
    this.settings = {
      container: '.items-list-container',
      max_items: this.attributes.desktop_max.value,
      threshold: this.attributes.scroll_steps.value,
      addtocart_enabled: this.attributes.qb_add.value,
    };
    let mql = window.matchMedia('(pointer: coarse)');

    if (mql.matches) {
      // touchscreen
      this.settings.max_items = this.attributes.mobile_max.value;
      this.touchQbMode();
    }

    this.upBtn = this.querySelector('.scroll-up-button');
    this.downBtn = this.querySelector('.scroll-down-button');
    this.scrollElement = this.querySelector(this.settings.container);
    let items = this.querySelectorAll('.qb-size-item');
    this.scrollThreshold = items[0].offsetHeight * this.settings.threshold;

    if (this.settings.addtocart_enabled) {
      items.forEach((item) => {
        let id = item.getAttribute('data-sibling-id');
        item.addEventListener('click', this.addToCart.bind(this, id));
      });
    }

    if (!mql.matches) {
      this.setListHeight();
    }

    if (this.upBtn) {
      this.upBtn.addEventListener('click', this.scroll.bind(this, 'up'), false);
    }
    if (this.downBtn) {
      this.downBtn.addEventListener('click', this.scroll.bind(this, 'down'), false);
    }
    this.setActiveSibling();
  }

  setListHeight() {
    const lists = this.querySelectorAll('.items-list.active');
    lists.forEach((listElement) => {
      let listItems = listElement.querySelectorAll('.qb-size-item');
      if (listItems.length >= this.settings.max_items) {
        var height = listItems[0].offsetHeight * this.settings.max_items;
        this.classList.add('show-arrows');
      } else {
        var height = listItems[0].offsetHeight * listItems.length;
      }
      this.querySelector('.items-list-container').style.cssText = `
              overflow: hidden;
              height: ${height}px;
            `;
    });
  }

  setActiveSibling() {
    // The listener itself is now module-level and registered once; see
    // bindActiveSiblingListener above for why. Only the list height is per-instance.
    bindActiveSiblingListener();
    this.setListHeight();
  }

  addToCart(id) {}

  touchQbMode() {
    // Observe ONLY this instance's own grid item. The previous version queried every
    // .collection .grid__item on the page from inside each instance, so N quick-buys over
    // M cards created N x M observations. That is merely wasteful with one page of
    // products and quadratic once load-more starts appending pages.
    const item = this.closest('.grid__item');
    if (!item) return;

    const itemsObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Null-guarded: plenty of grid items have no .qb at all (products with no size
          // option, the single-size path, and the article and page results on search).
          // Unguarded, this threw on every such card that scrolled into view.
          const qb = entry.target.querySelector('.qb');
          if (!qb) return;
          qb.classList.toggle('qb-mobile', entry.isIntersecting);
        });
      },
      { threshold: 1 }
    );
    itemsObserver.observe(item);
  }

  scroll(direction) {
    let newScrollTop;
    const currentScrollTop = this.scrollElement.scrollTop;

    if (direction === 'down') {
      newScrollTop = currentScrollTop + this.scrollThreshold;
      this.upBtn.style.display = 'flex';
      if (
        this.scrollElement.scrollTop >= this.scrollElement.offsetHeight ||
        this.scrollElement.scrollHeight - this.scrollElement.scrollTop == this.scrollElement.offsetHeight
      ) {
        // reached to bottom
        this.downBtn.style.display = 'none';
      }
    } else {
      newScrollTop = Math.max(0, currentScrollTop - this.scrollThreshold);
      this.downBtn.style.display = 'flex';
      if (newScrollTop === 0) {
        this.upBtn.style.display = 'none';
      }
    }

    if ('scrollBehavior' in document.documentElement.style) {
      this.scrollElement.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    } else {
      // Fallback for browsers that don't support smooth scrolling
      this.scrollElement.scrollTop = newScrollTop;
    }
  }
}
customElements.define('quick-buy', QuickBuy);
